import { bool, number, string } from 'prop-types'

export const hitsType = {
  activeSubstances: string.isRequired,
  attributes: string.isRequired,
  descriptionShort: string.isRequired,
  ean: string.isRequired,
  master: bool.isRequired,
  masterID: string.isRequired,
  manufacturer: string.isRequired,
  marketplace: bool.isRequired,
  packSize: string.isRequired,
  pharmaForm: string.isRequired,
  prescriptionMedicine: bool.isRequired,
  price: number.isRequired,
  productName: string.isRequired,
  pzn: string.isRequired,
  RPMultiplier: number.isRequired,
  RPStartDate: number.isRequired,
  RPEndDate: number.isRequired,
  stockStatusReason: bool,
  topsellerCount: number.isRequired,
}
